import BookDemoForm, { getServerSidePropsFunc } from '../bookafreehomedemo';
export default BookDemoForm;
export const getServerSideProps = getServerSidePropsFunc('/forbesselectvacuumcleaner/book-a-demo');
